export enum KT {
  KTString = 1,
  KTInt = 2,
  KTDouble = 3,
  KTBool = 4,
  KTLong = 5,
}
